import { render, staticRenderFns } from "./PromotionCodes.vue?vue&type=template&id=38d722a2"
import script from "./PromotionCodes.vue?vue&type=script&lang=js"
export * from "./PromotionCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports